/* Lanificio Trade, editie 2026: de collectie (filters, zoeken, meer tonen,
   proefstukken), maatplanner en de draad. Laadt met defer. */
(function(){
 /* ---------------------------------------------------------- de collectie
    Alle kaarten staan al in de HTML; filteren gebeurt hier zonder herladen.
    Per groep (stijl, vorm, kleur) één keuze, plus een zoekveld op naam of
    MZ-code. De eerste 24 resultaten zijn zichtbaar, "Meer kleden tonen"
    voegt er telkens 24 aan toe. Verborgen kaarten laden hun lazy foto niet. */
 const PAGE=24;
 const col=document.querySelector('[data-collection]');
 let layoutThread=function(){};
 if(col){
  const cards=[...col.querySelectorAll('.card')];
  const q=col.querySelector('[data-filter-q]');
  const countEl=col.querySelector('[data-filter-count]');
  const more=col.querySelector('[data-cards-more]');
  const empty=col.querySelector('[data-cards-empty]');
  const resets=col.querySelectorAll('[data-filter-reset]');
  const state={stijl:'',vorm:'',kleur:'',q:''};
  let limit=PAGE;
  const norm=s=>(s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/[^a-z0-9]/g,'');
  function matches(c){
   if(state.stijl&&!c.dataset.stijl.split(' ').includes(state.stijl))return false;
   if(state.vorm&&!c.dataset.vorm.split(' ').includes(state.vorm))return false;
   if(state.kleur&&!c.dataset.kleur.split(' ').includes(state.kleur))return false;
   if(state.q&&!norm(c.dataset.q).includes(state.q))return false;
   return true;
  }
  function render(){
   const hits=cards.filter(matches);
   cards.forEach(c=>{c.hidden=true});
   hits.forEach((c,i)=>{c.hidden=i>=limit});
   countEl.textContent=hits.length+(hits.length===1?' kleed':' kleden');
   more.hidden=hits.length<=limit;
   empty.hidden=hits.length>0;
   const active=state.stijl||state.vorm||state.kleur||state.q;
   resets[0].hidden=!active;
   requestAnimationFrame(layoutThread);
  }
  col.querySelectorAll('[data-filter]').forEach(group=>{
   const key=group.dataset.filter;
   group.addEventListener('click',e=>{
    const b=e.target.closest('button[data-value]'); if(!b)return;
    state[key]=b.dataset.value;
    group.querySelectorAll('button[data-value]').forEach(x=>x.setAttribute('aria-pressed',x===b?'true':'false'));
    limit=PAGE; render();
   });
  });
  let t;
  q.addEventListener('input',()=>{clearTimeout(t);t=setTimeout(()=>{state.q=norm(q.value);limit=PAGE;render()},120)});
  q.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();q.blur()}});
  resets.forEach(r=>r.addEventListener('click',()=>{
   state.stijl=state.vorm=state.kleur=state.q=''; q.value='';
   col.querySelectorAll('[data-filter] button[data-value]').forEach(x=>x.setAttribute('aria-pressed',x.dataset.value===''?'true':'false'));
   limit=PAGE; render();
  }));
  more.addEventListener('click',()=>{
   const firstNew=cards.filter(matches)[limit];
   limit+=PAGE; render();
   if(firstNew){const a=firstNew.querySelector('.card__name a'); if(a)a.focus({preventScroll:true})}
  });

  /* Proefstuk: zelfde winkelwagenregel als op de productpagina
     (assets/lan-proefstuk.js): properties Ontwerp, _ontwerp_handle en
     _ontwerp_afbeelding, hetzelfde ontwerp niet twee keer, maximaal
     settings.proefstuk_max per bestelling. */
  const cfg=window.LanTrade||{};
  const toast=col.querySelector('[data-sample-toast]'), msg=col.querySelector('[data-sample-msg]');
  let toastTimer;
  function say(text,withLink){
   msg.textContent=text; toast.querySelector('a').hidden=!withLink; toast.hidden=false;
   clearTimeout(toastTimer); toastTimer=setTimeout(()=>{toast.hidden=true},6000);
  }
  async function cartItems(){
   const r=await fetch(cfg.cart||'/cart.js',{credentials:'same-origin'});
   if(!r.ok)throw new Error('cart'); return (await r.json()).items||[];
  }
  col.addEventListener('click',async e=>{
   const b=e.target.closest('[data-sample]'); if(!b||b.disabled)return;
   if(!cfg.proefstukVariant){say('Proefstukken zijn tijdelijk niet te bestellen.');return}
   const name=b.dataset.title.split(' MZ-')[0];
   b.disabled=true; b.classList.add('is-busy');
   try{
    const items=await cartItems();
    const samples=items.filter(i=>i.handle==='proefstuk');
    if(samples.some(i=>i.properties&&i.properties._ontwerp_handle===b.dataset.handle)){
     b.textContent='In winkelwagen'; say('Een proefstuk van '+name+' zit al in je winkelwagen.',true); return;
    }
    const max=+cfg.proefstukMax||3;
    if(samples.reduce((n,i)=>n+i.quantity,0)>=max){b.disabled=false; say('Maximaal '+max+' proefstukken per bestelling.',true); return}
    const props={Ontwerp:b.dataset.title,_ontwerp_handle:b.dataset.handle};
    if(b.dataset.image)props._ontwerp_afbeelding=b.dataset.image;
    const r=await fetch(cfg.cartAdd||'/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+cfg.proefstukVariant,quantity:1,properties:props}]})});
    if(!r.ok)throw new Error('add');
    b.textContent='In winkelwagen'; say('Proefstuk van '+name+' toegevoegd.',true);
   }catch(err){
    b.disabled=false; say('Dat lukte niet. Probeer het nog eens.');
   }finally{b.classList.remove('is-busy')}
  });
 }

 /* ------------------------------------------------------- maatplanner
    Plattegrond van bovenaf op schaal: 1 SVG-eenheid = 1 cm. De bank staat
    met de rugleuning op y = 0 en is 95 cm diep; de voorpoten staan 4 cm
    binnen de hoeken. Het kleed groeit of krimpt in 0.5 s (ease), de meubels
    blijven staan. Het oordeel volgt uit de tekening zelf, zodat tekst en
    tekening altijd kloppen; bij een bank van 240 cm gelden de vaste teksten. */
 const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
 const planSvg=document.getElementById('planSvg');
 if(planSvg){
  const NS='http://www.w3.org/2000/svg';
  const SOFA_D=95, LEG=4, TABLE={w:120,h:60,cy:165}, ROUND_C=180, ROUND_TABLE=45;
  const SIZES={
   rect:[{name:'160 x 230',w:230,h:160,top:75},{name:'200 x 300',w:300,h:200,top:65},{name:'250 x 350',w:350,h:250,top:-5}],
   round:[{name:'Ø 200',d:200},{name:'Ø 250',d:250},{name:'Ø 300',d:300}]
  };
  const FIXED={rect:[
   [false,'Te klein voor deze bank: de voorpoten staan naast het kleed. Wel goed voor een fauteuilhoek of een 2-zits.'],
   [true,'Goed: de voorpoten staan op het kleed en het kleed steekt aan beide kanten 30 cm uit.'],
   [true,'Ruim: bank, fauteuil en tafel staan helemaal op het kleed. Voor een hele zithoek.']]};
  const el=id=>document.getElementById(id);
  const rugRect=el('rugRect'), rugEll=el('rugEll'), dims=el('dims'), sofaG=el('sofa'), setRect=el('setRect'), setRound=el('setRound'), legsG=el('legs');
  const sb=el('sizeBtns'), slider=el('sofaW'), out=el('sofaOut'), vIcon=el('verdictIcon'), vText=el('verdictText'), advice=el('advice'), desc=el('planDesc');
  let shape='rect', idx=1, W=240;
  const cur={rw:0,rh:0,rt:0,rd:0};

  function mk(tag,attrs,parent){const n=document.createElementNS(NS,tag);for(const k in attrs)n.setAttribute(k,attrs[k]);if(parent)parent.appendChild(n);return n}
  const r6=v=>Math.round(v*10)/10;
  /* Fauteuil van 80 x 80, lokaal gecentreerd, voorkant naar -y. */
  function chair(parent,cx,cy,rot){
   const g=mk('g',{transform:'translate('+cx+' '+cy+') rotate('+rot+')'},parent);
   mk('rect',{x:-40,y:-40,width:80,height:80,rx:6},g);
   mk('rect',{x:-40,y:24,width:80,height:16,rx:4},g);
   mk('rect',{x:-40,y:-40,width:12,height:64,rx:4},g);
   mk('rect',{x:28,y:-40,width:12,height:64,rx:4},g);
   mk('rect',{x:-25,y:-36,width:50,height:57,rx:4},g);
   return {cx,cy,rot};
  }
  /* Voorpoten van een fauteuil in wereldcoördinaten. */
  function chairFrontLegs(c){
   const a=c.rot*Math.PI/180, cs=Math.cos(a), sn=Math.sin(a);
   return [[-36,-36],[36,-36]].map(([x,y])=>[c.cx+x*cs-y*sn, c.cy+x*sn+y*cs]);
  }
  function chairCorners(c){
   const a=c.rot*Math.PI/180, cs=Math.cos(a), sn=Math.sin(a);
   return [[-40,-40],[40,-40],[40,40],[-40,40]].map(([x,y])=>[c.cx+x*cs-y*sn, c.cy+x*sn+y*cs]);
  }
  let chairsRect=[], chairsRound=[];
  function drawSofa(){
   sofaG.textContent='';
   const x0=-W/2, arm=18, back=20;
   mk('rect',{x:x0,y:0,width:W,height:SOFA_D,rx:7},sofaG);
   mk('rect',{x:x0+arm,y:0,width:W-2*arm,height:back,rx:4},sofaG);
   mk('rect',{x:x0,y:0,width:arm,height:SOFA_D,rx:6},sofaG);
   mk('rect',{x:-x0-arm,y:0,width:arm,height:SOFA_D,rx:6},sofaG);
   const n=W>=200?3:2, gap=2, inner=W-2*arm-2*gap, cw=(inner-(n-1)*gap)/n;
   for(let i=0;i<n;i++)mk('rect',{x:r6(x0+arm+gap+i*(cw+gap)),y:back+2,width:r6(cw),height:SOFA_D-back-6,rx:4},sofaG);
   legsG.textContent='';
   [[x0+LEG,LEG],[-x0-LEG,LEG],[x0+LEG,SOFA_D-LEG],[-x0-LEG,SOFA_D-LEG]].forEach(([x,y])=>mk('circle',{cx:x,cy:y,r:2.6},legsG));
   setRect.textContent='';
   mk('rect',{x:-TABLE.w/2,y:TABLE.cy-TABLE.h/2,width:TABLE.w,height:TABLE.h,rx:3},setRect);
   chairsRect=[chair(setRect,Math.max(118,W/2-2),188,-60)];
  }
  function drawRoundSet(){
   setRound.textContent='';
   mk('circle',{cx:0,cy:ROUND_C,r:ROUND_TABLE},setRound);
   chairsRound=[chair(setRound,-60,300,12),chair(setRound,60,300,-12)];
  }

  /* Maatlijnen met eindstreepjes en de maat in cm. De lettergrootte wordt
     omgerekend naar 11 px op het scherm, wat de breedte van de svg ook is. */
  function unit(){const w=planSvg.getBoundingClientRect().width||460;return 460/w}
  function dimLine(x1,y1,x2,y2,label,vertical){
   const u=unit(), t=4*u;
   mk('line',{x1,y1,x2,y2},dims);
   if(vertical){mk('line',{x1:x1-t,y1,x2:x1+t,y2:y1},dims);mk('line',{x1:x2-t,y1:y2,x2:x2+t,y2},dims)}
   else{mk('line',{x1,y1:y1-t,x2:x1,y2:y1+t},dims);mk('line',{x1:x2,y1:y2-t,x2,y2:y2+t},dims)}
   const tx=vertical?x1-7*u:(x1+x2)/2, ty=vertical?(y1+y2)/2:y1+14*u;
   const txt=mk('text',{x:tx,y:ty,'text-anchor':'middle','font-size':11*u},dims);
   if(vertical)txt.setAttribute('transform','rotate(-90 '+tx+' '+ty+')');
   txt.textContent=label;
  }
  function paint(){
   dims.textContent='';
   if(shape==='rect'){
    const x=-cur.rw/2, y=cur.rt;
    rugRect.setAttribute('x',r6(x));rugRect.setAttribute('y',r6(y));rugRect.setAttribute('width',r6(cur.rw));rugRect.setAttribute('height',r6(cur.rh));
    const gap=16*unit();
    dimLine(r6(x),r6(y+cur.rh+gap),r6(x+cur.rw),r6(y+cur.rh+gap),Math.round(cur.rw)+' cm',false);
    dimLine(r6(x-gap),r6(y),r6(x-gap),r6(y+cur.rh),Math.round(cur.rh)+' cm',true);
   }else{
    const r=cur.rd/2;
    rugEll.setAttribute('rx',r6(r));rugEll.setAttribute('ry',r6(r));
    const gap=16*unit();
    dimLine(r6(-r-gap),r6(ROUND_C-r),r6(-r-gap),r6(ROUND_C+r),'Ø '+Math.round(cur.rd)+' cm',true);
   }
  }

  /* 'ease' = cubic-bezier(.25,.1,.25,1) */
  function ease(t){
   const x1=.25,y1=.1,x2=.25,y2=1;
   const bx=s=>3*(1-s)*(1-s)*s*x1+3*(1-s)*s*s*x2+s*s*s, by=s=>3*(1-s)*(1-s)*s*y1+3*(1-s)*s*s*y2+s*s*s;
   let lo=0,hi=1,s=t; for(let i=0;i<20;i++){s=(lo+hi)/2; if(bx(s)<t)lo=s; else hi=s}
   return by(s);
  }
  let anim=0;
  function animateTo(target){
   const from={...cur}, t0=performance.now(), dur=reduce?0:500, id=++anim;
   function step(t){
    if(id!==anim)return;
    const k=dur?Math.min(1,(t-t0)/dur):1, e=ease(k);
    for(const key in target)cur[key]=from[key]+(target[key]-from[key])*e;
    paint(); if(k<1)requestAnimationFrame(step);
   }
   requestAnimationFrame(step);
  }

  const inRect=(p,x,y,w,h)=>p[0]>=x&&p[0]<=x+w&&p[1]>=y&&p[1]<=y+h;
  const inCircle=(p,r)=>Math.hypot(p[0],p[1]-ROUND_C)<=r;
  function judge(){
   const frontLegs=[[-W/2+LEG,SOFA_D-LEG],[W/2-LEG,SOFA_D-LEG]];
   if(shape==='rect'){
    const s=SIZES.rect[idx], x=-s.w/2, y=s.top, inside=p=>inRect(p,x,y,s.w,s.h);
    if(W===240)return FIXED.rect[idx];
    const legsOn=frontLegs.every(inside), over=Math.round((s.w-W)/2);
    const sofaAll=[[-W/2,0],[W/2,0],[-W/2,SOFA_D],[W/2,SOFA_D]].every(inside);
    const chairAll=chairsRect.every(c=>chairCorners(c).every(inside));
    if(!legsOn)return [false,'Te klein voor deze bank: de voorpoten staan naast het kleed. Wel goed voor een fauteuilhoek of een kleinere bank.'];
    if(sofaAll&&chairAll)return [true,'Ruim: bank, fauteuil en tafel staan helemaal op het kleed. Voor een hele zithoek.'];
    if(over<20)return [false,'Krap: de voorpoten staan op het kleed, maar het steekt aan beide kanten maar '+over+' cm uit. Kies liever een maat groter.'];
    if(over>40)return [true,'Ruim: de voorpoten staan op het kleed en het kleed steekt aan beide kanten '+over+' cm uit. Een maat kleiner past ook.'];
    return [true,'Goed: de voorpoten staan op het kleed en het kleed steekt aan beide kanten '+over+' cm uit.'];
   }
   const r=SIZES.round[idx].d/2, inside=p=>inCircle(p,r);
   const sofaOn=frontLegs.every(inside), chairsOn=chairsRound.every(c=>chairFrontLegs(c).every(inside));
   if(sofaOn&&chairsOn)return [true,'Goed: de voorpoten van de bank en van beide fauteuils staan op het kleed, met de ronde tafel in het midden.'];
   if(chairsOn)return [false,'Krap: de fauteuils staan met hun voorpoten op het kleed, de bank staat ernaast. Kies een maat groter, of een kleinere bank.'];
   if(sofaOn)return [false,'Bijna: de bank staat met de voorpoten op het kleed, de fauteuils staan ernaast.'];
   return [false,'Te klein voor deze zithoek: alleen de salontafel staat op het kleed. Mooi onder een ronde eettafel of in een leeshoek.'];
  }
  const ICON={ok:'<svg viewBox="0 0 12 12" width="12" height="12"><path d="M1.5 6.5 4.5 9.5 10.5 2.5" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>',
   no:'<svg viewBox="0 0 12 12" width="12" height="12"><path d="M2 2 10 10M10 2 2 10" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>'};
  function advise(){
   const lo=W+40, hi=W+60, list=SIZES[shape].map(s=>({name:s.name,w:shape==='rect'?s.w:s.d}));
   const fit=list.find(s=>s.w>=lo&&s.w<=hi), bigger=list.find(s=>s.w>hi);
   let txt='Vuistregel: kleedbreedte = bankbreedte plus 40 tot 60 cm. Bij een bank van '+W+' cm is dat '+lo+' tot '+hi+' cm';
   if(fit)txt+=': kies '+fit.name+' cm.';
   else if(bigger)txt+='. Geen standaardmaat valt daarbinnen: kies '+bigger.name+' cm, of laat het kleed op maat maken.';
   else txt+='. Dat is groter dan onze standaardmaten: we maken het kleed graag op maat.';
   advice.textContent=txt;
  }
  function update(animate){
   const [ok,text]=judge();
   vIcon.innerHTML=ok?ICON.ok:ICON.no; vIcon.className='verdict__icon '+(ok?'is-ok':'is-no');
   vText.textContent=text; advise();
   const s=SIZES[shape][idx];
   desc.textContent='Bank van '+W+' cm breed met een kleed van '+s.name+' cm. '+text;
   planSvg.dataset.shape=shape;
   const target=shape==='rect'?{rw:s.w,rh:s.h,rt:s.top}:{rd:s.d};
   if(animate)animateTo(target); else{Object.assign(cur,target);paint()}
  }
  function renderBtns(){
   sb.innerHTML=SIZES[shape].map((s,i)=>'<button aria-pressed="'+(i===idx)+'" data-i="'+i+'">'+s.name+(shape==='rect'?' cm':' cm')+'</button>').join('');
   sb.querySelectorAll('button').forEach(b=>b.onclick=()=>{idx=+b.dataset.i;renderBtns();update(true)});
  }
  document.querySelectorAll('[data-shape]').forEach(b=>b.onclick=()=>{
   if(shape===b.dataset.shape)return;
   shape=b.dataset.shape;
   /* Vloeiend van vorm wisselen: de nieuwe vorm begint op de maat van de oude. */
   if(shape==='round')cur.rd=Math.min(cur.rw,cur.rh);
   else Object.assign(cur,{rw:cur.rd,rh:cur.rd,rt:ROUND_C-cur.rd/2});
   document.querySelectorAll('[data-shape]').forEach(x=>x.setAttribute('aria-pressed',x===b?'true':'false'));
   renderBtns(); update(true);
  });
  slider.addEventListener('input',()=>{W=+slider.value; out.textContent=W+' cm'; drawSofa(); update(false)});
  addEventListener('resize',()=>requestAnimationFrame(paint));
  drawSofa(); drawRoundSet(); renderBtns();
  /* Start: het kleed groeit uit het midden open zodra de plattegrond in beeld komt. */
  Object.assign(cur,{rw:0,rh:0,rt:SIZES.rect[idx].top+SIZES.rect[idx].h/2,rd:0}); update(false);
  Object.assign(cur,{rw:0,rh:0,rt:SIZES.rect[idx].top+SIZES.rect[idx].h/2}); paint();
  if('IntersectionObserver' in window){
   const io=new IntersectionObserver(es=>{if(es.some(e=>e.isIntersecting)){io.disconnect();update(true)}},{threshold:.3});
   io.observe(planSvg);
  }else update(true);
 }

 /* ------------------------------------------------- maatplanner in 3D
    Met WebGL krijgt de sectie .is-3d (de 3D-keuzes en -ruimte tonen, de
    plattegrond verbergen) en laadt assets/lan-planner-3d.js (stand
    'collectie') pas zodra de sectie in
    de buurt komt. Zonder WebGL, of als het laden mislukt, blijft de
    plattegrond hierboven staan. */
 const planner=document.querySelector('[data-planner]');
 if(planner){
  const cfg=window.LanTrade||{};
  let gl=null;
  try{const c=document.createElement('canvas');gl=c.getContext('webgl2')||c.getContext('webgl')}catch(e){gl=null}
  if(gl&&cfg.stage&&cfg.three&&cfg.orbit&&'IntersectionObserver' in window){
   planner.classList.add('is-3d');
   const fail=err=>{console.warn('[Lanificio] 3D-maatplanner niet geladen, plattegrond als terugval.',err);planner.classList.remove('is-3d');requestAnimationFrame(layoutThread)};
   const io=new IntersectionObserver(es=>{
    if(!es.some(e=>e.isIntersecting))return;
    io.disconnect();
    import(cfg.stage).then(m=>m.default(planner,{...cfg,mode:'collectie'})).then(()=>requestAnimationFrame(layoutThread)).catch(fail);
   },{rootMargin:'400px 0px'});
   io.observe(planner);
  }
 }

 /* the thread: one line through the document, drawn by scrolling */
 const svg=document.getElementById('thread'), path=document.getElementById('threadPath');
 let len=0, y0=0, y1=1;
 function pt(el,side){
  const r=el.getBoundingClientRect(), sy=scrollY, vw=document.documentElement.clientWidth, g=Math.max(20,Math.min(64,vw*0.04));
  if(side==='l') return [g*0.5, r.top+sy+r.height/2];
  if(side==='r') return [vw-g*0.5, r.top+sy+r.height/2];
  return [r.left+r.width/2, r.top+sy+r.height/2];
 }
 layoutThread=function(){
  const H=document.documentElement.scrollHeight, vw=document.documentElement.clientWidth;
  svg.setAttribute('viewBox','0 0 '+vw+' '+H); svg.style.height=H+'px';
  const pts=[];
  document.querySelectorAll('[data-knot]').forEach(el=>{
   const k=el.dataset.knot; if(el.offsetParent===null&&k!=='hero')return;
   pts.push(pt(el,k==='l'?'l':k==='r'?'r':'c'));
  });
  if(pts.length<2)return;
  let d='M'+pts[0][0]+' '+pts[0][1];
  for(let i=1;i<pts.length;i++){
   const [x0,y0_]=pts[i-1],[x1,y1_]=pts[i], dy=(y1_-y0_);
   const sw=(i%2?1:-1)*vw*(vw<900?0.05:0.18);
   d+=' C'+(x0+sw)+' '+(y0_+dy*0.35)+' '+(x1-sw)+' '+(y1_-dy*0.35)+' '+x1+' '+y1_;
  }
  path.setAttribute('d',d); len=path.getTotalLength();
  path.style.strokeDasharray=len; y0=pts[0][1]; y1=pts[pts.length-1][1];
  update();
 };
 function update(){
  if(reduce){path.style.strokeDashoffset=0;return}
  const head=scrollY+innerHeight*0.62; const p=Math.max(0,Math.min(1,(head-y0)/(y1-y0)));
  path.style.strokeDashoffset=len*(1-p);
 }
 addEventListener('scroll',update,{passive:true});
 addEventListener('resize',()=>requestAnimationFrame(layoutThread));
 if(document.fonts&&document.fonts.ready)document.fonts.ready.then(layoutThread);
 addEventListener('load',layoutThread); layoutThread();

})();
